/**
 * Shared URL helpers. Deliberately permissive: it answers "is this a usable
 * http(s) URL", nothing more. Callers that need stricter rules (a real public
 * domain, an explicit scheme) layer their own checks on top - webhook and
 * callback URLs legitimately point at localhost and bare IPs.
 */
export const isValidUrl = (url: string): boolean => {
  try {
    const u = new URL(url);
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch (err) {
    return false;
  }
}
